"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.higherThanLastActual = exports.isReadingOutsideThreshold = exports.tierOutsideThreshold = void 0;
var getLatestImportantReading_1 = require("./getLatestImportantReading");
var tierOutsideThreshold = function (newRegister, latestReadingTiers) {
    return (latestReadingTiers !== null && latestReadingTiers !== void 0 ? latestReadingTiers : []).filter(function (latestReadingTier) {
        return newRegister.timeOfUseLabel === latestReadingTier.timeOfUseLabel &&
            parseInt(newRegister.value) < latestReadingTier.meterRegisterReading;
    }).length > 0;
};
exports.tierOutsideThreshold = tierOutsideThreshold;
var isReadingOutsideThreshold = function (readToValidate, readToValidateAgainst) {
    return readToValidate.registers.filter(function (register) {
        return (0, exports.tierOutsideThreshold)(register, readToValidateAgainst.tiers);
    }).length > 0;
};
exports.isReadingOutsideThreshold = isReadingOutsideThreshold;
//OEA apparently want inline validation against only actual reads.
//Can we confirm this with them and possibly combine this with actual and industry opening estimates?
//Or better yet move all of this validation to Reads and Reconciliation team
var higherThanLastActual = function (newRegister, currentReadings) {
    var latestActualReading = (0, getLatestImportantReading_1.getLatestActualReading)(currentReadings);
    return latestActualReading
        ? (0, exports.tierOutsideThreshold)(newRegister, latestActualReading.tiers)
        : false;
};
exports.higherThanLastActual = higherThanLastActual;
